import { PeopleService } from '@/services';
import { ArchiveInterface, PeopleToBeArchived } from '@/types';
import { defineStore } from 'pinia';

interface State {
  isShow: boolean;
  person: {
    id: number;
    display_name: string;
    archived_at: string;
    people_type: {
      acronym: string;
    };
  };
  peopleToBeArchived: PeopleToBeArchived[];
  peopleToBeArchivedTotal: number;
  peopleToBeArchivedLoading: boolean;
}

export default defineStore('ArchiveStore', {
  state: (): State => {
    return {
      isShow: false,
      person: {
        id: 0,
        display_name: '',
        archived_at: '',
        people_type: {
          acronym: '',
        },
      },
      peopleToBeArchived: [],
      peopleToBeArchivedTotal: 0,
      peopleToBeArchivedLoading: false,
    };
  },

  actions: {
    async unarchive(id: number) {
      return await PeopleService.unarchive(id).catch((e) => {
        throw e;
      });
    },

    async archive(id: number, payload: ArchiveInterface) {
      return await PeopleService.archive(id, payload).catch((e) => {
        throw e;
      });
    },

    async toBeArchived() {
      this.peopleToBeArchivedLoading = true;
      const response = await PeopleService.toBeArchived();
      this.peopleToBeArchived = response.data.data;
      this.peopleToBeArchivedTotal = this.peopleToBeArchived.length;
      this.peopleToBeArchivedLoading = false;
    },

    async archiveKeep(personId: number) {
      try {
        const response = await PeopleService.archiveKeep(personId);
        const message = response.data.success;
        await this.toBeArchived();
        this.defineSuccessMessage(message);
      } catch (error) {
        this.defineErrorMessage(error);
      }
    },

    defineSuccessMessage(message: { message: string; title: string }) {
      this.doToast(message.message, message.title);
    },

    // eslint-disable-next-line
    // @ts-ignore
    defineErrorMessage(error) {
      this.doToast(error.data.error.message, error.data.error.title, true);
    },
  },
});
